import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PermissionsManagerDirective } from './permissions-manager.directive';
import { UnauthorizedComponent } from 'src/app/pages/unauthorized/unauthorized.component';
import { MaterialAppModule } from 'src/app/material.module';

@NgModule({
  declarations: [PermissionsManagerDirective, UnauthorizedComponent],
  exports: [PermissionsManagerDirective, UnauthorizedComponent],
  imports: [CommonModule, MaterialAppModule],
})
export class PermissionsManagerModule {}
